// Lib
import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Flex, Button, Text } from 'rebass';

// Hooks
import useGetShareLink from 'components/Modal/ShareLinkModal/hooks/useGetShareLink';

const NavButton = styled(Button)`
  margin-top: 30px;
  text-transform: none;
`;

interface EmptyRecruiterProps {
  jobId: number;
}

const EmptyRecruiter: React.FC<EmptyRecruiterProps> = ({ jobId }): JSX.Element => {
  const dispatch = useDispatch();
  const { getShareLinkHandler } = useGetShareLink(jobId);
  const pathToAddCandidate = () => dispatch(push(`/add-candidate/${jobId}`));

  return (
    <Flex flexDirection="column" alignItems="center" css="margin-bottom: 30px;">
      Let&apos;s get started
      <br />
      <NavButton variant="primary" onClick={pathToAddCandidate}>
        Add a candidate
      </NavButton>
      <Text css="margin-top: 30px">or</Text>
      <NavButton variant="primary" onClick={getShareLinkHandler}>
        Share a link
      </NavButton>
    </Flex>
  );
};

export default EmptyRecruiter;
